import * as Html from "../../util/Html.ts";
import * as DateUtils from '../../lib/DateUtils.ts';


function init(node){
  
  var 
    inputVisible = node.next('[type="date"]').first();
  
  inputVisible.on('change',function(){
    if(this.value!==''){
      var 
        result = new Date(this.value+'T'+DateUtils.forInputTime(new Date())),
        resultISO = result.toISOString();
      //security for infinite loop with change event
      if(resultISO!==node.val()){
        node.val(result.toISOString()).trigger('change');
      }
    }else{
      this.value = DateUtils.forInputDate(new Date(node.val()))
    }
  })  
    
}
Html.registerWidget('widget/form/input-date-timenow',{init:init})

export {init}